<template>
  <div>
    <MobileMenu :customMenu="customMenu" />
    <TopBar
      :is-hide-menu="isHideMenu"
      :bread-crumb-list="breadCrumbList"
      :class="(!isOnlineMode) || (isOnlineMode && currentNetwork && localDataFound && getPermission) || currentEnvMode == 'development' ? 'mb-2' : 'mb-12'"
    />
    <AlertCustom
      v-if="currentEnvMode == 'development'"
      :class="(!isOnlineMode) || (isOnlineMode && currentNetwork && localDataFound && getPermission) ? '!mb-2' : '!mb-6'"
      class="!py-3 mx-10"
      theme-color="warning"
      title="ขณะนี้กำลังใช้งานอยู่ในระบบทดสอบ"
    />
    <AlertCustom
      v-if="!isOnlineMode"
      theme-color="dark"
      title="ขณะนี้กำลังใช้งานอยู่ในโหมดออฟไลน์"
      class="!py-3 mx-10"
    >
      <template
        v-if="currentNetwork"
        #content-end
      >
        <button
          type="button"
          class="btn btn-outline-secondary p-1 px-4 mr-1"
          @click="switchToOnline"
        >
          ออนไลน์
        </button>
      </template>
    </AlertCustom>
    <AlertCustom
      v-if="isOnlineMode && currentNetwork && localDataFound && getPermission"
      theme-color="primary"
      title="ตรวจพบข้อมูลที่ยังไม่บันทึก"
      class="gap-1 !py-3 mx-10"
    >
      <template #content-end>
        <div>
          <button
            type="button"
            class="btn btn-outline-secondary border-red text-red p-1 px-4 mr-1 hover:bg-transparent"
            @click="clearOfflineData"
          >
            ลบทิ้ง
          </button>
          <button
            type="button"
            class="btn btn-outline-primary p-1 px-4 mr-1 hover:bg-transparent"
            @click="syncOfflineData"
          >
            Sync
          </button>
        </div>
      </template>
    </AlertCustom>
    <!-- <div class="wrapper">
      <div class="wrapper-box"> -->
        <!-- BEGIN: Content -->
        <div class="content--top-nav">
          <slot />
        </div>
        <!-- END: Content -->
      <!-- </div>
    </div> -->
  </div>
</template>

<script>
import { defineComponent, computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "@/store";
import TopBar from "@/components/top-bar/Main.vue";
import MobileMenu from "@/components/mobile-menu/Main.vue";
import localForage from "localforage";
import Swal from "sweetalert2"

const swalCustom = Swal.mixin({
    customClass: {
        confirmButton: "btn btn-primary m-1",
        cancelButton: "btn btn-outline-secondary m-1",
    },
    buttonsStyling: false,
});

const houseStore = localForage.createInstance({
    name        : 'mpi-logbook',
    storeName   : 'house'
});

export default defineComponent({
  components: {
    TopBar,
    MobileMenu,
  },
  props: {
    isHideMenu: {
      type: Boolean,
      default: false,
    },
    breadCrumbList:{
      type: Array
    },
    customMenu: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const currentNetwork = ref(false)
    const localDataFound = ref(0)

    const isOnlineMode = computed(() => store.getters['network/isOnline'])
    const getPermission = computed(() => store.getters["userAuth/getUserTumbolCode"].length == 6 && route.name != "sync-page")
    const statusSync = computed(()=> store.getters['network/statusSync'])
    currentNetwork.value = navigator.onLine

    watch(statusSync, async ()=>{
      if(!statusSync.value){
        localDataFound.value = await houseStore.length()
      }
    })

    onMounted(async() => {
      cash("body")
        .removeClass("error-page")
        .removeClass("login")
        .addClass("main");
      window.addEventListener("online", ()=>{
        currentNetwork.value = navigator.onLine
      });
      window.addEventListener("offline", ()=>{
        currentNetwork.value = navigator.onLine
      });
      localDataFound.value = await houseStore.length()
    });

    const switchToOnline = () =>{
      navigator.serviceWorker.controller.postMessage({value: navigator.onLine})
    }
    const syncOfflineData = () =>{
      store.dispatch('network/setStatusSync', true)
      router.push({
        name: "sync-page"
      })
    }
    const clearOfflineData = async () => {
      swalCustom.fire({
          text:"ยืนยันลบข้อมูล",
          icon:"warning",
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก',
      }).then(async (result) => {
          if (result.isConfirmed) {
            await houseStore.clear()
            localDataFound.value = await houseStore.length()
            if(localDataFound.value == 0){
              router.push({
                name: 'main-house-hold'
              })
            }
          }
      })
    }
    const currentEnvMode = computed(()=> process.env.VUE_APP_ENV)

    return {
      isOnlineMode,
      currentNetwork,
      localDataFound,
      switchToOnline,
      syncOfflineData,
      clearOfflineData,
      getPermission,
      currentEnvMode
    };
  },
});
</script>

<style lang="scss" scoped>
.content--top-nav {
  width: 100%;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
</style>
